/* eslint-disable import/no-named-as-default */
import React, { FunctionComponent, Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import portalLogo from "../../shared/general/img/hhPortalLogo.png";
import premiumLogo from "../../shared/general/img/hhPremiumLogo.png";
import logoPink from "../../shared/general/img/logoPink.png";
import PlacementSummary from "../AgencyPerformance/PlacementSummary";
import FillRate from "../AgencyPerformance/FillRate";
import TimeToSubmission from "../AgencyPerformance/TimeToSubmission";
import LeagueTable from "../AgencyPerformance/LeagueTable";
import pdfExportOptionsTypes from "../types/pdfExportOptionsTypes";
import {
  Wrapper,
  Inner,
  PortalLogo,
  PremiumLogo,
  HhLogo,
  Charts,
  NoneSelected,
  Footer,
  FooterText,
  FooterTime,
} from "../styles/pdf-export-page-styles";

interface IOptionItemProps {
  id: number;
  value: string;
  isChecked: boolean;
  label: string;
}

export interface IAgencyExportPageProps {
  preview?: boolean;
  isPortalUser: boolean;
  isPremiumUser: boolean;
  options: Array<IOptionItemProps>;
  noneSelected?: boolean;
}

export const AgencyPerformancePdfExportPage: FunctionComponent<
  IAgencyExportPageProps
> = ({ preview, options, isPortalUser, isPremiumUser, noneSelected }) => {
  const date: Date = new Date();
  const dateToDisplay = `${date.toLocaleString("default", {
    month: "long",
  })} ${date.getDate()}, ${date.getFullYear()} | ${date.getHours()}:${
    date.getMinutes() < 10 ? "0" : ""
  }${date.getMinutes()}`;

  const placementSummary = options[8];
  const fillRate = options[9];
  const timeToSubmission = options[10];
  const leagueTable = options[11];

  return (
    <Wrapper
      preview={preview}
      id={preview ? "agency-performance-preview" : "pdf-export-page"}
    >
      {isPortalUser && (
        <PortalLogo
          src={portalLogo as string}
          alt="Portal logo"
          noneSelected={noneSelected}
        />
      )}
      {isPremiumUser && (
        <PremiumLogo
          src={premiumLogo as string}
          alt="HH Premium logo"
          noneSelected={noneSelected}
        />
      )}
      {!isPortalUser && !isPremiumUser && (
        <HhLogo
          src={logoPink as string}
          alt="HH logo"
          noneSelected={noneSelected}
        />
      )}
      <Inner>
        {noneSelected ? (
          <NoneSelected>
            Please select at least one chart to export
          </NoneSelected>
        ) : (
          <Fragment>
            <Charts>
              {placementSummary.isChecked && <PlacementSummary pdfExport />}
            </Charts>
            <Charts>{fillRate.isChecked && <FillRate pdfExport />}</Charts>
            <Charts>
              {timeToSubmission.isChecked && <TimeToSubmission pdfExport />}
            </Charts>
            <Charts>
              {leagueTable.isChecked && <LeagueTable pdfExport />}
            </Charts>
          </Fragment>
        )}
      </Inner>
      <Footer>
        {isPortalUser && (
          <FooterText>
            Portal by <strong>Hiring Hub</strong>
          </FooterText>
        )}
        {isPremiumUser && (
          <FooterText>
            <strong>Hiring Hub</strong> Premium
          </FooterText>
        )}
        {!isPortalUser && !isPremiumUser && (
          <FooterText>
            <strong>Hiring Hub</strong>
          </FooterText>
        )}
        <FooterTime>{dateToDisplay}</FooterTime>
      </Footer>
    </Wrapper>
  );
};

AgencyPerformancePdfExportPage.propTypes = {
  preview: PropTypes.bool,
  options: pdfExportOptionsTypes.isRequired,
  isPortalUser: PropTypes.bool.isRequired,
  isPremiumUser: PropTypes.bool.isRequired,
  noneSelected: PropTypes.bool,
};

AgencyPerformancePdfExportPage.defaultProps = {
  preview: null,
  noneSelected: null,
};

interface IReduxState {
  employerAnalytics: {
    pdfExportOptions: {
      options: Array<IOptionItemProps>;
    };
    isPortalUser: boolean;
    isPremiumUser: boolean;
  };
}

const mapStateToProps = (state: IReduxState) => ({
  options: state.employerAnalytics.pdfExportOptions.options,
  isPortalUser: state.employerAnalytics.isPortalUser,
  isPremiumUser: state.employerAnalytics.isPremiumUser,
});

export default connect(mapStateToProps, {})(AgencyPerformancePdfExportPage);
